import { FC, useEffect, useMemo } from 'react';
import PageWrapper from 'components/UI/PageWrapper';
import { Column, Grid } from 'styles';
import { useParams } from 'react-router';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import * as routes from 'router/Routes';
import {
  fetchSoftwareById,
  softwareDetailsSelector,
} from 'store/softwareState/softwareState';
import { SoftwareDetailsSuccess } from 'models';
import SoftwareInfoCard from 'components/software/SoftwareInfoCard';
import ReleaseCard from 'components/software/ReleaseCard';
import RolloutCard from 'components/software/RolloutCard';
import ErrorCard from 'components/ErrorCard';

const SoftwareDetailsPage: FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();

  const { isLoading, data, error }: SoftwareDetailsSuccess = useAppSelector(
    softwareDetailsSelector,
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchSoftwareById(id));
    }
  }, [dispatch, id]);

  const softwareInfoContent = useMemo(() => {
    if (!id) {
      return null;
    }
    return <SoftwareInfoCard software={data} isLoading={isLoading} />;
  }, [id, data, isLoading]);

  const releasedForContent = useMemo(() => {
    if (!id) {
      return null;
    }
    return <ReleaseCard software={data} isLoading={isLoading} />;
  }, [id, data, isLoading]);

  const rolloutContent = useMemo(() => {
    return <RolloutCard software={data} />;
  }, [data]);

  if (error) {
    return (
      <PageWrapper>
        <ErrorCard
          navTitle="software.title"
          route={routes.SOFTWARES}
          title={error.title}
          errorMessage={error.detail || error.title}
        />
      </PageWrapper>
    );
  }
  return (
    <PageWrapper>
      <Grid>{softwareInfoContent}</Grid>
      <Grid>
        <Column $marginRight>{releasedForContent}</Column>
        <Column>{rolloutContent}</Column>
      </Grid>
    </PageWrapper>
  );
};
export default SoftwareDetailsPage;
